import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id F57CEB13-5A41-498C-BCF5-D7036E7B1122
 * name blinds-vertical
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/blinds-vertical.svg
 * tags
 * - Home Automation 
 */
export const BlindsVerticalIcon = createSvgIcon(<><path d="M20 19V3H4V19H2V21H22V19H20M10 19V5H14V19H10Z" /></>, 'BlindsVerticalIcon');
export default BlindsVerticalIcon